/**
 * 支付管理 支付配置
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>营收记录</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-date-picker
                v-model="value"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="selectTime" 
              >
              </el-date-picker>
      </el-form-item>
    </el-form>
    <el-col :span="36">
        <!-- 六个订单信息 -->
        <div class="num">
          <el-card
            shadow="hover"
            v-for="item in countData"
            :key="item.name"
            :body-style="{ display: 'flex', padding: 0 }"
            class="OrderCard"
          >
            <i
              class="icon"
              :class="'el-icon-' + item.icon"
              :style="{ background: item.color }"
            ></i>
            <div class="textBox">
              <p class="important-font">￥{{ item.value }}</p>
              <p class="secondary-font">{{ item.name }}</p>
            </div>
          </el-card>
        </div>
      </el-col>
      <el-table size="small" :data="message.maplist" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" type="index" width="60">
        </el-table-column>
        <el-table-column  prop="time" label="时间" show-overflow-tooltip>
        </el-table-column>
        <el-table-column  prop="turnover" label="营业额"  show-overflow-tooltip >
        </el-table-column>
        <el-table-column  prop="profit" label="利润"  show-overflow-tooltip>
        </el-table-column>
        <el-table-column  prop="totalOrderNum" label="订单量"  show-overflow-tooltip>
        </el-table-column>
        <el-table-column  prop="totalNum" label="商品量"  show-overflow-tooltip>
        </el-table-column>
      </el-table>
    <!-- 分页组件 -->
    <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->
  </div>
</template>

<script>
import { ConfigList, ConfigSave, ConfigDelete } from "../../api/payMG";
import Pagination from "../../components/Pagination";
import {getSalesRecord} from '../../api/api.js'
export default {
  data() {
    return {
      loading: false, //是显示加载
      // editFormVisible: false, //控制编辑页面显示与隐藏
      //6个表格的内容
      countData: [
        {
          name: "总营业额",
          value: 1200,
          icon: "success",
          color: "#2ec7c9",
        },
        {
          name: "日最高营业额",
          value: 1200,
          icon: "star-on",
          color: "#ffb980",
        },
        {
          name: "日均营业额",
          value: 1200,
          icon: "s-goods",
          color: "#5ab1ef",
        },
        {
          name: "总利润",
          value: 1200,
          icon: "success",
          color: "#2ec7c9",
        },
        {
          name: "日最高利润",
          value: 1200,
          icon: "star-on",
          color: "#ffb980",
        },
        {
          name: "日均利润",
          value: 1200,
          icon: "s-goods",
          color: "#5ab1ef",
        },
      ],
      value: "",//获取的时间
      message:'',//营销数据
      formInline: {
        page: 1,
        limit: 10,
        name: "",
        payType: 0,
        partner: "",
        token: localStorage.getItem("logintoken"),
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    //获取当前时间
    let endDate = new Date();
    //把当前时间减10天，赋值到开始时间
    let startDate = new Date().setDate(endDate.getDate() - 10);
    let date = [startDate,endDate]
    this.value = date
    this.getdata(date);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取营销数据
    getdata(date) {
      //把date转换成2023-01-01格式
      console.log(date,'11111')
      let startDate = new Date(date[0]);
      let endDate = new Date(date[1]);
      this.startTime =
      startDate.getFullYear() +
        "-" +
        ("0" + (startDate.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + startDate.getDate()).slice(-2);
      this.endTime =
        endDate.getFullYear() +
        "-" +
        ("0" + (endDate.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + endDate.getDate()).slice(-2);
      this.loading = true;
      console.log(this.startTime,this.endTime,'333333')
      getSalesRecord({
        startTime : this.startTime,
        endTime: this.endTime,
        storeId: localStorage.getItem('storeId'),
      }).then((res)=>{
        this.loading = false;
        if (res.code==0) {
          // this.orderList = res.data.maplist;
          this.message = res.data
          this.countData[0].value = res.data.totalTurnover
          this.countData[1].value = res.data.maxTurnover
          this.countData[2].value = res.data.avgTurnover
          this.countData[3].value = res.data.totalProfit
          this.countData[4].value = res.data.maxProfit
          this.countData[5].value = res.data.avgProfit
        } else {
          this.$message({
            type: "info",
            message: res.msg,
          });
        }
      }).catch((err)=>{
        this.loading = false;
        this.$message.error("营销数据获取失败，请稍后再试！");
      })
    },
    // 选择时间触发的函数
    selectTime(date) {
      this.getdata(date);
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {
        this.title = "修改";
        this.editForm.id = row.id;
        this.editForm.name = row.name;
        this.editForm.payType = row.payType;
        this.editForm.partner = row.partner;
        this.editForm.subMchId = row.subMchId;
        this.editForm.appid = row.appid;
        this.editForm.notifyUrl = row.notifyUrl;
        this.editForm.signType = row.signType;
        this.editForm.partnerKey = row.partnerKey;
        this.editForm.sellerUserId = row.sellerUserId;
        this.editForm.certPath = row.certPath;
        this.editForm.certPassword = row.certPassword;
        this.editForm.rsaKey = row.rsaKey;
      } else {
        this.title = "添加";
        this.editForm.id = "";
        this.editForm.name = "";
        this.editForm.payType = "";
        this.editForm.partner = "";
        this.editForm.subMchId = "";
        this.editForm.appid = "";
        this.editForm.notifyUrl = "";
        this.editForm.signType = "";
        this.editForm.partnerKey = "";
        this.editForm.sellerUserId = "";
        this.editForm.certPath = "";
        this.editForm.certPassword = "";
        this.editForm.rsaKey = "";
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          ConfigSave(this.editForm)
            .then((res) => {
              this.editFormVisible = false;
              this.loading = false;
              if (res.success) {
                this.getdata(this.formInline);
                this.$message({
                  type: "success",
                  message: "公司保存成功！",
                });
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.editFormVisible = false;
              this.loading = false;
              this.$message.error("支付配置信息保存失败，请稍后再试！");
            });
        } else {
          return false;
        }
      });
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          ConfigDelete(row.deptId)
            .then((res) => {
              if (res.success) {
                this.$message({
                  type: "success",
                  message: "公司已删除!",
                });
                this.getdata(this.formInline);
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("支付配置信息删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false;
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}

.num {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.OrderCard {
  margin: 0 0 20px 30px;
  border: #dcdfe6 1px solid;
  border-radius: 10px;
  /* height: 80px; */
}
.icon {
  width: 30%;
  line-height: 100px;
  font-size: 30px;
  color: #fff;
  text-align: center;
}
.textBox {
  /* background-color: red; */
  width: 33vw;
  text-align: center;
}

.important-font {
  font-weight: 900;
  font-size: 20px;
}
.secondary-font {
  color: #909399;
}
</style>





// WEBPACK FOOTER //
// src/views/pay/Config.vue